import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeleteDefaultTodoMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type DeleteDefaultTodoMutation = { __typename?: 'HyperionSchemaMutation', projectDefualtTodoTypeHyperionMutation?: { __typename?: 'ProjectDefualtTodo', mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', argument?: string | null, errorsMsgs?: Array<string | null> | null, infoMsgs?: Array<string | null> | null, model?: string | null, modelErrorsMsgs?: Array<string | null> | null, modelSuccessMsgs?: Array<string | null> | null, modelWarningMsgs?: Array<string | null> | null, msg?: string | null, mutationSucceeded?: boolean | null, successMsgs?: Array<string | null> | null, warningMsgs?: Array<string | null> | null } | null> | null } | null };

export const DeleteDefaultTodoDocument = gql`
    mutation deleteDefaultTodo($id: Int) {
  projectDefualtTodoTypeHyperionMutation(deleteProjectDefualtTodo: {id: $id}) {
    mutationDetails {
      argument
      errorsMsgs
      infoMsgs
      model
      modelErrorsMsgs
      modelSuccessMsgs
      modelWarningMsgs
      msg
      mutationSucceeded
      successMsgs
      warningMsgs
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDefaultTodoGQL extends Apollo.Mutation<DeleteDefaultTodoMutation, DeleteDefaultTodoMutationVariables> {
    document = DeleteDefaultTodoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }